/* eslint-disable */
export const ReportsStyle = () => ({
  messageBar: {
    root: {
      width: "100%",
      maxWidth: "940px",
    },
  },
});
